import Vue from "vue";
import VueRouter from "vue-router";
import App from "@/App.vue";
import ViewerSearch from "@/components/ViewerSearch.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", component: App },
    { path: "/chat", component: App, meta: { requiresAuth: true } },
    { path: "/viewer", component: ViewerSearch, meta: { requiresAuth: true } },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) return next();
  const token = localStorage.getItem("session_token");
  if (!token) return next("/login");
  next();
});

export default router;